import { takeLatest, put, all, call } from "redux-saga/effects";
import cashInOutActionTypes from "./cash-in-out-types";
import { requestERPLYData } from "../../api/Server";
import { createRequestData, getResponseData } from "../../utils/index";

function* getReasonCodes({ payload: { sessionKey, clientCode, isIframe } }) {
  const request = {
    requests: createRequestData(100, {
      requestName: "getReasonCodes",
      recordsOnPage: 100,
      sendContentType: 1,
    }),
    clientCode,
  };

  if (isIframe || sessionKey) {
    request.sessionKey = sessionKey;
  }

  try {
    const response = yield call(requestERPLYData, request);

    if (response.data.status.responseStatus === "error") {
      yield put({
        type: cashInOutActionTypes.GET_REASON_CODE_FAILED,
      });
    } else {
      yield put({
        type: cashInOutActionTypes.GET_REASON_CODE_SUCCESS,
        payload: getResponseData(response.data.requests),
      });
    }
  } catch (error) {
    yield put({
      type: cashInOutActionTypes.GET_REASON_CODE_FAILED,
    });
  }
}

function* getEmployees({
  payload: { sessionKey, clientCode, lang, isIframe },
}) {
  const request = {
    requests: createRequestData(100, {
      requestName: "getEmployees",
      recordsOnPage: 100,
      sendContentType: 1,
      lang,
    }),
    clientCode,
  };

  if (isIframe || sessionKey) {
    request.sessionKey = sessionKey;
  }

  try {
    const response = yield call(requestERPLYData, request);

    if (response.data.status.responseStatus === "error") {
      yield put({
        type: cashInOutActionTypes.GET_EMPLOYEES_FAILED,
      });
    } else {
      yield put({
        type: cashInOutActionTypes.GET_EMPLOYEES_SUCCESS,
        payload: getResponseData(response.data.requests),
      });
    }
  } catch (error) {
    yield put({
      type: cashInOutActionTypes.GET_EMPLOYEES_FAILED,
    });
  }
}

function* getStoreRegions({
  payload: { sessionKey, clientCode, lang, isIframe },
}) {
  const request = {
    requests: createRequestData(100, {
      requestName: "getStoreRegions",
      recordsOnPage: 100,
      sendContentType: 1,
      lang,
    }),
    clientCode,
  };

  if (isIframe || sessionKey) {
    request.sessionKey = sessionKey;
  }

  try {
    const response = yield call(requestERPLYData, request);

    if (response.data.status.responseStatus === "error") {
      yield put({
        type: cashInOutActionTypes.GET_STORE_REGIONS_FAILED,
      });
    } else {
      yield put({
        type: cashInOutActionTypes.GET_STORE_REGIONS_SUCCESS,
        payload: getResponseData(response.data.requests),
      });
    }
  } catch (error) {
    yield put({
      type: cashInOutActionTypes.GET_STORE_REGIONS_FAILED,
    });
  }
}

function* getWarehouses({
  payload: { sessionKey, clientCode, lang, isIframe },
}) {
  const request = {
    request: "getWarehouses",
    clientCode,
    lang,
    sendContentType: 1,
  };

  if (isIframe || sessionKey) {
    request.sessionKey = sessionKey;
  }

  try {
    const response = yield call(requestERPLYData, request);
    if (response.data.status.responseStatus === "error") {
      yield put({
        type: cashInOutActionTypes.GET_WAREHOUSE_FAILED,
      });
    } else {
      yield put({
        type: cashInOutActionTypes.GET_WAREHOUSE_SUCCESS,
        payload: response.data.records,
      });
    }
  } catch (error) {
    yield put({
      type: cashInOutActionTypes.GET_WAREHOUSE_FAILED,
    });
  }
}

function* getPointOfSales({ payload: { sessionKey, clientCode, isIframe } }) {
  const request = {
    request: "getPointsOfSale",
    clientCode,
    sendContentType: 1,
  };

  if (isIframe || sessionKey) {
    request.sessionKey = sessionKey;
  }

  try {
    const response = yield call(requestERPLYData, request);
    if (response.data.status.responseStatus === "error") {
      yield put({
        type: cashInOutActionTypes.GET_POINT_OF_SALE_FAILED,
      });
    } else {
      yield put({
        type: cashInOutActionTypes.GET_POINT_OF_SALE_SUCCESS,
        payload: response.data.records,
      });
    }
  } catch (error) {
    yield put({
      type: cashInOutActionTypes.GET_POINT_OF_SALE_FAILED,
    });
  }
}

export function* getSessionUser({
  payload: { sessionKey, clientCode, isIframe },
}) {
  const request = {
    request: "getSessionKeyUser",
    clientCode,
    sendContentType: 1,
  };
  if (isIframe || sessionKey) {
    request.sessionKey = sessionKey;
  }
  try {
    const response = yield call(requestERPLYData, request);

    if (response.data.status.responseStatus === "error") {
      yield put({
        type: cashInOutActionTypes.GET_SESSION_USER_FAILED,
      });
    } else {
      yield put({
        type: cashInOutActionTypes.GET_SESSION_USER_SUCCESS,
        payload: response.data.records[0],
      });
    }
  } catch (error) {
    yield put({
      type: cashInOutActionTypes.GET_SESSION_USER_FAILED,
    });
  }
}

export function* onGetSessionUserStart() {
  yield takeLatest(cashInOutActionTypes.GET_SESSION_USER_START, getSessionUser);
}

function* onGetPointOfSalesStart() {
  yield takeLatest(
    cashInOutActionTypes.GET_POINT_OF_SALE_START,
    getPointOfSales
  );
}

function* onGetStoreRegionsStart() {
  yield takeLatest(
    cashInOutActionTypes.GET_STORE_REGIONS_START,
    getStoreRegions
  );
}

function* onGetWarehousesStart() {
  yield takeLatest(cashInOutActionTypes.GET_WAREHOUSE_START, getWarehouses);
}

function* onGetReasonCodesStart() {
  yield takeLatest(cashInOutActionTypes.GET_REASON_CODE_START, getReasonCodes);
}

function* onGetEmployeesStart() {
  yield takeLatest(cashInOutActionTypes.GET_EMPLOYEES_START, getEmployees);
}

export function* cashInOutSagas() {
  yield all([
    call(onGetReasonCodesStart),
    call(onGetEmployeesStart),
    call(onGetWarehousesStart),
    call(onGetPointOfSalesStart),
    call(onGetSessionUserStart),
    call(onGetStoreRegionsStart),
  ]);
}
